export type PagedList<T> = {
    data: T[];
    offset: number;
    total: number;
    limit: number;
};

export type NameValueAmountDto = {
    name?: string;
    value: number;
    amount: number;
};

export type KeyValuePair<TKey, TValue> = {
    key: TKey;
    value: TValue;
};

export type ICountTotal = {
    name: string;
    value: number;
    amount: number;
    date: string;
};

export function getLoanStatusDisplay(loanStatusCode: string) {
    switch (loanStatusCode) {
        case "X":
        case "A":
        case "Z":
            return "Active";
        case "W":
        case "T":
        case "D":
        case "t":
        case "P":
            return "Closed";
        default:
            return "";
    }
}
